import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionTiposVariablesIncentivosService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.variables;
  }

  getTodo() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getTodoPorId(id: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorId + id);
  }

  getTodoPorEstado(estado: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorEstado + estado);
  }

  save(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crear, innObj);
  }

  update(innObj: any) {
    console.log("updateTipoDeVendedore", innObj)
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.actualizar, innObj);
  }

  delete(innIdDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar + `${innIdDireccion}`);
  }

  getRecursos() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.tiposDeRecursos);
  }

  getVariables() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.tiposDeVariables);
  }

  getMedidas(medida: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.tiposDeMedidas + medida);
  }

}
